import { OnboardingRoutesWithProvider } from "@leagueplatform/onboarding";
import { Box, styled } from "@leagueplatform/genesis-core";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import {
  ANALYTICS_SCREEN_NAMES,
  PRODUCT_AREA_NAMES,
  SUB_PRODUCT_AREA_NAMES,
  TENANT_ID,
} from "common/constants";

const Wrapper = styled(Box, {
  "& ul": {
    listStyle: "none",
    paddingInlineStart: 0,
  },
});

const FEATURE_HIGHLIGHT_STYLES = {
  mobileSlideHeaderStyles: {
    "&:before": {
      backgroundColor: "$decorativeBrandPrimaryBrightest",
    },
  },
};

type Props = {
  onOnboardingComplete: () => void;
};

export const OnboardingFeatureHighlightsPage = ({
  onOnboardingComplete,
}: Props) => {
  usePageViewAnalytics({
    product_area: PRODUCT_AREA_NAMES.FOUNDATION,
    sub_product_area: SUB_PRODUCT_AREA_NAMES.ONBOARDING,
    screen_name: ANALYTICS_SCREEN_NAMES.SIGN_IN,
  });

  return (
    <Wrapper>
      <OnboardingRoutesWithProvider
        contentfulId={import.meta.env.VITE_ONBOARDING_CONTENTFUL_ID}
        tenantId={TENANT_ID}
        featureHighlightStyles={FEATURE_HIGHLIGHT_STYLES}
        onOnboardingComplete={(error) => {
          if (error) {
            // eslint-disable-next-line no-console
            console.error("[onboarding] feature highlights error", error);
          }
          onOnboardingComplete();
        }}
      />
    </Wrapper>
  );
};
